
import axios from '@/utils/ajax/index'; // 倒入 api
import fileExport from '@/utils/fileExport/index'; // 导出文件 api

// 获取诊所基本信息
export const getHospitalInfo = (params) => {
  return axios({
    url: '/hospitalManage/hospital/getHospitalInfo',
    method: 'get',
    params,
  });
};

// 科室列表
export const getListLaboratory = (params) => {
  return axios({
    url: '/hospitalManage/laboratory/listLaboratory',
    method: 'get',
    params,
  });
};


// 新增科室
export const insertLaboratory = (data) => {
  return axios({
    url: '/hospitalManage/laboratory/insertLaboratory',
    method: 'post',
    data,
  });
};

// 修改科室
export const updateLaboratory = (data) => {
  return axios({
    url: '/hospitalManage/laboratory/updateLaboratory',
    method: 'post',
    data,
  });
};

// 删除科室
export const deleteLaboratory = (params) => {
  return axios({
    url: '/hospitalManage/laboratory/deleteLaboratory',
    method: 'get',
    params,
  });
};

// 分页查询诊所下面员工
export const getDoctorList = (params) => {
  return axios({
    url: '/hospitalManage/doctor/pageDoctor',
    method: 'get',
    params,
  });
};
// 删除员工
export const deleteDoctor = (params) => {
  return axios({
    url: '/hospitalManage/doctor/deleteDoctor',
    method: 'get',
    params,
  });
};

// 增加员工
export const insertDoctor = (data) => {
  return axios({
    url: '/hospitalManage/doctor/insertDoctor',
    method: 'post',
    data,
  });
};

// 修改员工
export const updateDoctor = (data) => {
  return axios({
    url: '/hospitalManage/doctor/updateDoctor',
    method: 'post',
    data,
  });
};

// 获取角色列表
export const getRoleList = (params) => {
  return axios({
    url: '/hospitalManage/role/listRole',
    method: 'get',
    params,
  });
};

// 获取角色列表-分页
export const getPageRole = (params) => {
  return axios({
    url: '/hospitalManage/role/pageRole',
    method: 'get',
    params,
  });
};

// 获取角色详情
export const getRole = (params) => {
  return axios({
    url: '/hospitalManage/role/getRole',
    method: 'get',
    params,
  });
};

// 删除角色
export const deleteRole = (params) => {
  return axios({
    url: '/hospitalManage/role/deleteRoleAndPermission',
    method: 'get',
    params,
  });
};

// 新增角色
export const insertRoleAndPermission = (data) => {
  return axios({
    url: '/hospitalManage/role/insertRoleAndPermission',
    method: 'post',
    data,
  });
};

// 修改角色
export const updateRoleAndPermission = (data) => {
  return axios({
    url: '/hospitalManage/role/updateRoleAndPermission',
    method: 'post',
    data,
  });
};

// 获取角色权限菜单列表
export const ztreeList = (params) => {
  return axios({
    url: 'hospitalManage/permission/ztreeList',
    method: 'get',
    params,
  });
};

// 分页查询诊所下面所有检查治疗项
export const listPagedExam = (data) => {
  return axios({
    url: '/hospitalManage/exam/listPagedExam',
    method: 'post',
    data,
  });
};

// 新增、修改检查治疗项
export const saveOrEditExam = (data) => {
  return axios({
    url: '/hospitalManage/exam/saveOrEditExam',
    method: 'post',
    data,
  });
};

// 删除检查治疗项
export const deleteExam = (data) => {
  return axios({
    url: '/hospitalManage/exam/deleteExam',
    method: 'post',
    data,
  });
};

// 查询模板
export const lisTemplate = (params) => {
  return axios({
    url: '/hospitalManage/template/lisTemplate',
    method: 'get',
    params,
  });
};

// 添加医嘱模板
export const insertDoctorAdviceTemplate = (data) => {
  return axios({
    url: '/hospitalManage/template/insertDoctorAdviceTemplate',
    method: 'post',
    data,
  });
};

// 删除医嘱模板
export const deleteTemplate = (params) => {
  return axios({
    url: '/hospitalManage/template/deleteTemplate',
    method: 'get',
    params,
  });
};

// 修改模板
export const updateDoctorAdviceTemplate = (data) => {
  return axios({
    url: '/hospitalManage/template/updateDoctorAdviceTemplate',
    method: 'post',
    data,
  });
};

// 查询挂号项
export const pageRegisterType = (params) => {
  return axios({
    url: '/hospitalManage/hospitalRegisterType/pageRegisterType',
    method: 'get',
    params,
  });
};

// 删除挂号项
export const deleteRegisterType = (params) => {
  return axios({
    url: '/hospitalManage/hospitalRegisterType/deleteRegisterType',
    method: 'get',
    params,
  });
};

// 新增挂号项
export const insertRegisterType = (data) => {
  return axios({
    url: '/hospitalManage/hospitalRegisterType/insertRegisterType',
    method: 'post',
    data,
  });
};

// 修改挂号项
export const updateRegisterType = (data) => {
  return axios({
    url: '/hospitalManage/hospitalRegisterType/updateRegisterType',
    method: 'post',
    data,
  });
};

// 查询中药处方模板详情
export const getChineseDrugRecipe = (params) => {
  return axios({
    url: '/hospitalManage/template/getChineseDrugRecipe',
    method: 'get',
    params,
  });
};

// 西药处方模板详情查询
export const getDrugRecipe = (params) => {
  return axios({
    url: '/hospitalManage/template/getDrugRecipe',
    method: 'get',
    params,
  });
};

// 查询输液处方模板详情
export const getInfusionRecipe = (params) => {
  return axios({
    url: '/hospitalManage/template/getInfusionRecipe',
    method: 'get',
    params,
  });
};

// 查询敷贴处方模板详情
export const getStickingDrugGroupRecipe = (params) => {
  return axios({
    url: '/hospitalManage/template/getStickingDrugGroupRecipe',
    method: 'get',
    params,
  });
};

// 修改饮片处方模板
export const updateChineseDrugRecipe = (data) => {
  return axios({
    url: '/hospitalManage/template/updateChineseDrugRecipe',
    method: 'post',
    data,
  });
};

// 修改成药处方模板
export const updateDrugRecipe = (data) => {
  return axios({
    url: '/hospitalManage/template/updateDrugRecipe',
    method: 'post',
    data,
  });
};

// 修改输液处方模板
export const updateInfusionRecipe = (data) => {
  return axios({
    url: '/hospitalManage/template/updateInfusionRecipe',
    method: 'post',
    data,
  });
};

// 修改敷贴模板
export const updateStickingDrugGroupRecipe = (data) => {
  return axios({
    url: '/hospitalManage/template/updateStickingDrugGroupRecipe',
    method: 'post',
    data,
  });
};

// 新增饮片处方模板
export const insertChineseDrugRecipe = (data) => {
  return axios({
    url: '/hospitalManage/template/insertChineseDrugRecipe',
    method: 'post',
    data,
  });
};

// 新增成药处方模板
export const insertDrugRecipe = (data) => {
  return axios({
    url: '/hospitalManage/template/insertDrugRecipe',
    method: 'post',
    data,
  });
};

// 新增输液处方模板
export const insertInfusionRecipe = (data) => {
  return axios({
    url: '/hospitalManage/template/insertInfusionRecipe',
    method: 'post',
    data,
  });
};

// 新增敷贴模板
export const insertStickingDrugGroupRecipe = (data) => {
  return axios({
    url: '/hospitalManage/template/insertStickingDrugGroupRecipe',
    method: 'post',
    data,
  });
};

// 查询敷贴处方模板详情
export const namelist = (data) => {
  return axios({
    url: '/drugsManage/drugs/template/namelist',
    method: 'post',
    data,
    hideLoading: true,
  });
};

// 获取打印配置
export const getPrintConfit = (params) => {
  return axios({
    url: '/hospitalManage/hospital/getPrintConfit',
    method: 'get',
    params,
  });
};

// 保存打印设置
export const savePrintConfig = (data) => {
  return axios({
    url: '/hospitalManage/hospital/savePrintConfig',
    method: 'post',
    data,
  });
};

// 删除饮片模板处方中的药品
export const templateChineseDrugpieces = (data) => {
  return axios({
    url: `/hospitalManage/template/templateChineseDrugpieces/${data.id}`,
    method: 'delete',
    data,
  });
};

// 删除西药模板处方中的药品
export const templateDrug = (data) => {
  return axios({
    url: `/hospitalManage/template/templateDrug/${data.id}`,
    method: 'delete',
    data,
  });
};

// 删除输液模板处方中的药品
export const templateInfusionDrug = (data) => {
  return axios({
    url: `/hospitalManage/template/templateInfusionDrug/${data.id}`,
    method: 'delete',
    data,
  });
};

// 删除贴敷模板处方中的药品
export const templateStickingDrug = (data) => {
  return axios({
    url: `/hospitalManage/template/templateStickingDrug/${data.id}`,
    method: 'delete',
    data,
  });
};
// 添加附加费用模板
export const insertAdditonalTemplate = (data) => {
  return axios({
    url: '/hospitalManage/template/insertAdditonalTemplate',
    method: 'post',
    data,
  });
};

// 修改附加费用模板
export const updateAdditionalTemplate = (data) => {
  return axios({
    url: '/hospitalManage/template/updateAdditionalTemplate',
    method: 'post',
    data,
  });
};

// 获取诊所基础功能配置
export const getHospitalConfig = (params) => {
  return axios({
    url: '/hospitalManage/hospital/getHospitalConfig',
    method: 'get',
    params,
  });
};

// 诊所设置
export const saveHospitalConfig = (data) => {
  return axios({
    url: '/hospitalManage/hospital/saveHospitalConfig',
    method: 'post',
    data,
  });
};

export default {
  getHospitalInfo,
  getListLaboratory,
  insertLaboratory,
  updateLaboratory,
  deleteLaboratory,
  getDoctorList,
  deleteDoctor,
  getRoleList,
  getPageRole,
  getRole,
  insertDoctor,
  updateDoctor,
  deleteRole,
  insertRoleAndPermission,
  updateRoleAndPermission,
  ztreeList,
  listPagedExam,
  saveOrEditExam,
  deleteExam,
  lisTemplate,
  insertDoctorAdviceTemplate,
  deleteTemplate,
  updateDoctorAdviceTemplate,
  pageRegisterType,
  deleteRegisterType,
  insertRegisterType,
  updateRegisterType,
  getChineseDrugRecipe,
  getDrugRecipe,
  getInfusionRecipe,
  getStickingDrugGroupRecipe,
  updateChineseDrugRecipe,
  updateDrugRecipe,
  updateInfusionRecipe,
  updateStickingDrugGroupRecipe,
  insertChineseDrugRecipe,
  insertDrugRecipe,
  insertInfusionRecipe,
  insertStickingDrugGroupRecipe,
  namelist,
  getPrintConfit,
  savePrintConfig,
  templateChineseDrugpieces,
  templateDrug,
  templateInfusionDrug,
  templateStickingDrug,
  insertAdditonalTemplate,
  updateAdditionalTemplate,
  getHospitalConfig,
  saveHospitalConfig,
};
